import {
  type AnyMessage,
  isCall,
  isEmail,
} from "@/app/[tenant]/(console)/comms/chat/window/message/message";

import type { ChatChannel } from "./contexts";

export const CHANNEL_FILTER_LABELS: Record<ChatChannel, string> = {
  sms: "Texts",
  patient_portal: "Patient portal",
  web_chat: "Web chat",
  call: "Calls",
  email: "Emails",
};

export function getChatChannel(item: AnyMessage): ChatChannel {
  if (isEmail(item)) return "email";
  if (isCall(item)) return "call";
  return item.channel ?? "sms";
}

function searchableText(item: AnyMessage): string {
  if (isEmail(item)) return `${item.subject ?? ""} ${item.snippet ?? ""}`;
  if (isCall(item)) return item.summary ?? "";
  return item.content ?? "";
}

/** Whether a thread item passes the chosen channels and search. */
export function matchesChatFilter(
  item: AnyMessage,
  channels: ReadonlySet<ChatChannel>,
  searchQuery: string,
): boolean {
  if (channels.size > 0 && !channels.has(getChatChannel(item))) return false;
  return (
    !searchQuery ||
    searchableText(item).toLowerCase().includes(searchQuery.toLowerCase())
  );
}
